<template>
<div class="basis-page-cls" v-loading="loading">
        <section class="basis-cls_table">
            <div class="header">
                <span class="title">群组管理</span>
                <div class="btns">
					<el-popover
						placement="bottom-end"
						width="300"
						v-model="visible">
						<p style="font-size: 14px; color: #172B4D;">请选择群组：</p>
						<br>
						<el-cascader v-model="groupIds" :props="props" :options="groupList" :collapse-tags="true" filterable clearable size="mini" style="width: 100%"></el-cascader>
						<br><br>
						<div style="text-align: right;">
							<el-button @click.stop="visible = false" size="mini" type="text" >取消</el-button>
							<el-button @click.stop="handelCreate" :loading="loading" type="primary" size="mini">确定</el-button>
						</div>
						<el-button slot="reference" type="primary" size="mini" icon="el-icon-circle-plus-outline" class="right">添加群组</el-button>
					</el-popover>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
					<template v-slot:right="{ row }">
						<el-dropdown @command="(command) => {return handleUpdate(command, row)}" trigger="click">
							<span class="el-dropdown-link">
								{{row.right == '6' ? '管理' : '只读'}} <i class="el-icon-caret-bottom"></i>
							</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="6">管理</el-dropdown-item>
							<el-dropdown-item command="1">只读</el-dropdown-item>
						</el-dropdown-menu>
						</el-dropdown>
					</template>
				</table-pagination>
            </div>
        </section>
    </div>
</template>

<script>
import Users from './Users';
export default {
	components: {Users},
	props: ['row'],
	data() {
		return {
			groupIds: [],
			groupList: [],
			props: {
				multiple: true,
				checkStrictly: true,
				emitPath: false,
				label: 'groupName',
				value: 'groupId'
			},
			visible: false,
			resourceType: '',
			column: [
				{ label: '群组', prop: 'groupName' },
				{
                    label: '权限',
                    prop: 'right',
					slotScope: true
                },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 80,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<el-button 
								type="danger"
								size="mini"
								onClick={() => this.handleDelete(scope.row)}>
								删除
							</el-button>
						)
                    }
                }
            ],
			listQuery: {
				projectId: '',
				id: '',
				pageNum: 1,
				pageSize: 10
			},
			list: [],
			total: 0,
			loading: false
		}
	},
	watch: {
		visible: {
			handler(val) {
				if(val) {
					this.$api.apiGetGroupList(this.row.projectId).then(response => {
						if(response.errcode != 0) {
							return;
						}
						this.groupList = this.translateDataToTree(response.data || []);
					});
				}
			},
			immediate:true,
			deep: true
		},
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.row.projectId;
			this.listQuery.id = this.row.id;
			this.$api.apiPostKnowledgeSelectResourceGroupList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				this.loading = false;
				this.visible = false;
			});
		},
		handelCreate() {
			if(this.groupIds.length === 0) {
				this.$message({
					message: '请选择群组',
					type: 'warning'
				});
				return;
			}
			this.loading = true;
			this.$api.apiPostKnowledgeResourceAddResourceGroup({
				resourceId: this.row.id,
				groupIds: this.groupIds,
				right: 1
			}).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.getList();
			});
		},
		translateDataToTree(data, parentGroupId = null) {
			const self = this;
			let tree = [];
			let temp;
			data.forEach((item, index) => {
				if (data[index].parentGroupId == parentGroupId) {
					let obj = data[index];
					temp = self.translateDataToTree(data, data[index].groupId);
					if (temp?.length > 0) {
						obj.children = temp;
					}
					tree.push(obj);
				}
			})
			return tree;
		},
		handleUpdate(command, row) {	
			if(command == row.right) return;
			this.$confirm(`是否切换此群组为 ${command == '1' ? '只读' : '管理'} ？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeResourceEditResourceGroup({
					projectId: row.projectId,
					id: row.rightId,
					right: command
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList();
				});
			}).catch(() => {});
		},
		handleDelete(row) {
			this.$confirm(`是否删除 ${row.groupName}？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeResourceDeleteResourceGroup({
					projectId: row.projectId,
					id: row.rightId
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList();
				});
			}).catch(() => {});
		}
	}
}
</script>